export default {
  list: [
    {
      title: 'فعال',
      value: 'ACTIVE'
    },
    {
      title: 'غیرفعال',
      value: 'INACTIVE'
    }
  ],
  values: {
    INACTIVE: 'INACTIVE',
    ACTIVE: 'ACTIVE'
  }
};
